function gridImplementation() {
let filterList = [];
let parString = '';
let inputString = '';
if(window.location.search.includes('filter')) {
let pars = new URLSearchParams(window.location.search);
let keySet = Array.from(new Set(pars.keys()));
for(i=0; i < keySet.length; i++) {
  if(keySet[i].includes('filter.p')) {
    continue;
  }
  let keyObj = { key: keySet[i], values: [] }
  filterList.push(keyObj)
}
let parSet = Array.from(pars)
for(i=0; i < parSet.length; i++) {
  if(parSet[i][0] != 'model' && parSet[i][0] != 'sort_by' && parSet[i][1].length > 0) {
    if(parSet[i][0] == 'idx') {
      localStorage.setItem('idx', parSet[i][1]);
    }
    if(parSet[i][0] == 'ID') {
      localStorage.setItem('vID', parSet[i][1]); 
    }
    if(parSet[i][0].includes('filter.v.m.tyre_spec.size_full')) {
      parString = `${parString}&${parSet[i][0]}=${parSet[i][1]}`;
      inputString = `${inputString}<input type="hidden" name="filter.v.m.tyre_spec.size_full" value="${parSet[i][1]}" class="facet-filter-checkbox" checked form="FacetsFilterForm">`
    }
  }
}
parString = `${parString.replace('&','?filter_params')}endparam`;
for(i=0; i < filterList.length; i++) {
  for(q=0; q < parSet.length; q++) {
     if(filterList[i].key == parSet[q][0]) {
       if(filterList[i].key == 'sort_by') {
         filterList.splice(i,1);
         continue;
       }
       if(parSet[q][1] == '0') {
         filterList[i].values.push('false');
       } else if (parSet[q][1] == '1') {
         filterList[i].values.push('true');
       } else if (parSet[q][1].length > 0) {
        filterList[i].values.push(parSet[q][1]); 
       } else {
         filterList.splice(i,1);
       }
     }
  }
}
}
  if(document.getElementById('formTarget')) {
    document.getElementById('formTarget').outerHTML = inputString;
  }
  let prodCards = document.querySelectorAll('product-card');
  for(i = 0; i < prodCards.length; i++) {
    if(prodCards[i].querySelector('script').dataset.category && prodCards[i].querySelector('script').dataset.category.toLowerCase().includes('wheel')) {
      continue;
    }
    let varData = JSON.parse(prodCards[i].getElementsByClassName('fullSizing')[0].textContent);
    let chosenVariant
    let chosenArray = [];
    if(filterList.length > 0) {
    for(q = 0; q < varData.length; q++) {
      let specCheck = [];
      for(g = 0; g < varData[q].vMeta.length; g++) {
         for(z = 0; z < filterList.length; z++) {
           if(filterList[z].key.includes('price')) {
             if(filterList[z].key.includes('.lte') && filterList[z].values[0].length > 0) {
               if(Number(varData[q].vPrice) <= (Number(filterList[z].values[0]) * 100)) {
                 specCheck.push(1);
               } else {
                 specCheck.push(0);
               }
             }
             if(filterList[z].key.includes('.gte') && filterList[z].values[0].length > 0) {
               if(Number(varData[q].vPrice) >= (Number(filterList[z].values[0]) * 100)) {
                 specCheck.push(1);
               } else {
                 specCheck.push(0);
               }
             }
           } else {
           if(filterList[z].key == varData[q].vMeta[g].filterName) {
             specCheck.push(1);
             if(!filterList[z].values.includes(varData[q].vMeta[g].value)) {
               specCheck.push(0);
             }
           }
         }
        }
      }
      if(specCheck.includes(1) && !specCheck.includes(0)) {
        if(!chosenVariant) {
          chosenVariant = varData[q];
        }
        chosenArray.push(varData[q]);
      }
    }
  } else {
      chosenVariant = varData[0];
      chosenArray = varData;
  }

    if(chosenVariant) {
      let grid = document.getElementById('product-grid').getElementsByClassName('grid-item');
      let availArray = chosenArray.filter(variant => variant.vAvailability == 'false' && variant.vManagement == 'shopify');
      if(availArray.length == chosenArray.length) {
        if(!prodCards[i].getElementsByClassName('plpStock')[0].classList.contains('obscure')) {
          prodCards[i].getElementsByClassName('plpStock')[0].classList.add('obscure');
        }
        /*let hideArray = chosenArray.filter(variant => variant.vAvailability == 'false' && variant.vPolicy == 'deny' && variant.vManagement == 'shopify');
        if(hideArray.length == chosenArray.length) {
          if(!grid[i].classList.contains('hidden')) {
            grid[i].classList.add('hidden');
          }
        } else {
          if(grid[i].classList.contains('hidden')) {
            grid[i].classList.remove('hidden');
          }
        }*/
      } else {
        if(grid[i].classList.contains('hidden')) {
            grid[i].classList.remove('hidden');
          }
        if(prodCards[i].getElementsByClassName('plpStock')[0].classList.contains('obscure')) {
          prodCards[i].getElementsByClassName('plpStock')[0].classList.remove('obscure');
        }
      }
      let address = prodCards[i].querySelector('a').href.substring(0,prodCards[i].querySelector('a').href.indexOf('?'));
      let pushPrice = `$${chosenVariant.vPrice.substring(0,(chosenVariant.vPrice.length - 2))}.${chosenVariant.vPrice.substring((chosenVariant.vPrice.length - 2),chosenVariant.vPrice.length)}`;
      if(chosenArray.length > 1) {
        pushPrice = `<span class="sup">From</span>${pushPrice}`
      }
      if(parString.length > 0) {
        let addressHREF = `${address}?variant=${chosenVariant.vID}?${parString}`
        addressHREF = addressHREF.replaceAll(' ','+');
        prodCards[i].querySelectorAll('a')[0].href = addressHREF;
        prodCards[i].querySelectorAll('a')[2].href = addressHREF;
        prodCards[i].getElementsByClassName('price-item')[0].innerHTML = pushPrice;
      }
      if(prodCards[i].innerHTML.includes('Buy 3')) {
          let buy3Price = chosenVariant.vPrice - 2500;
          buy3Price = buy3Price.toString();
          let buy3PushPrice = `SAVE $${buy3Price.substring(0,(buy3Price.length - 2))}`;
          prodCards[i].getElementsByClassName('primary_promotion')[0].querySelector('h3').innerHTML = buy3PushPrice;
      } else if(prodCards[i].innerHTML.includes('% Off')) {
          let pcPrice = prodCards[i].innerHTML.split('% Off')[0].substring((prodCards[i].innerHTML.split('% Off')[0].length - 2),prodCards[i].innerHTML.split('% Off')[0].length);
          pcPrice = Number(pcPrice);
          let pcPushPrice = Math.floor((chosenVariant.vPrice * 4) * (pcPrice / 100));
          pcPushPrice = pcPushPrice.toString();
          prodCards[i].getElementsByClassName('primary_promotion')[0].querySelector('h3').innerHTML = `SAVE $${pcPushPrice.substring(0,(pcPushPrice.length - 2))}`
      } else if(prodCards[i].innerHTML.toLowerCase().includes('cash back')) {
          let pcPrice = prodCards[i].getElementsByClassName('ribbon')[0].innerHTML.toLowerCase().split(' cash')[0].substring((prodCards[i].getElementsByClassName('ribbon')[0].innerHTML.toLowerCase().split(' cash')[0].indexOf('$') + 1), prodCards[i].getElementsByClassName('ribbon')[0].innerHTML.toLowerCase().split(' cash')[0].length);
          pcPrice = Number(pcPrice);
          let pcPushPrice = pcPrice;
          pcPushPrice = pcPushPrice.toString();
          prodCards[i].getElementsByClassName('primary_promotion')[0].querySelector('h3').innerHTML = `SAVE $${pcPushPrice}`;
      }
      if(chosenVariant.vIconsLeft.length > 0 ) {
        let leftIcoHTML = '';
        for(h = 0; h < chosenVariant.vIconsLeft.length; h++) {
          if(h > 2) {
            leftIcoHTML = `${leftIcoHTML}<div class="promotion-placeholder-new plus ${chosenVariant.vIconsLeft.length}"><div class="plus_icon">+ ${chosenVariant.vIconsLeft.length - 3}}</div></div>`;
            break
          }
          leftIcoHTML = `${leftIcoHTML}<div class="promotion-placeholder-new actual ${h}"><img src="${chosenVariant.vIconsLeft[h].url}" width="40" height="40"><br><span>${chosenVariant.vIconsLeft[h].description}</span></div>`
         }
        document.getElementsByClassName('badgeLeft')[i].innerHTML = `<div class="badges-overlay-left">${leftIcoHTML}</div>`
      }
      if(chosenVariant.vIconsRight.length > 0 ) {
        let rightIcoHTML = '';
        for(h = 0; h < chosenVariant.vIconsRight.length; h++) {
          if(h > 2) {
            rightIcoHTML = `${rightIcoHTML}<div class="promotion-placeholder-new plus ${chosenVariant.vIconsRight.length}"><div class="plus_icon">+ ${chosenVariant.vIconsRight.length - 3}}</div></div>`;
            break
          }
          rightIcoHTML = `${rightIcoHTML}<div class="promotion-placeholder-new actual ${h}"><img src="${chosenVariant.vIconsRight[h].url}" width="40" height="40"><br><span>${chosenVariant.vIconsRight[h].description}</span></div>`
         }
        document.getElementsByClassName('badgeRight')[i].innerHTML = `<div class="badges-overlay-left">${rightIcoHTML}</div>`
      }
    }
  }
  observation.observe(document.getElementById("ProductGridContainer"), {
    subtree: true,
    childList: true,
  });
}

document.addEventListener('DOMContentLoaded', function () {
  gridImplementation()
});

const observation = new MutationObserver(() => {
  observation.disconnect()
  setTimeout(gridImplementation,500)
});
